<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" (ngSubmit)="save(machineForm.value)" [formGroup]="machineForm">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin">
              <h2>
                <span
                  ><strong>{{ 'plugins.equipment-info.product-line' | translate }}<i>*</i></strong></span
                >
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group" formGroupName="data">
                <validation-message
                  [validationControl]="formData.controls.ProductLine"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input type="hidden" name="ProductLine" class="ir-form-set" formControlName="ProductLine" />
                <div class="ir-line ir-select th-select" (click)="openProductLinesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      productLineSelectedValue
                        ? productLineSelectedValue
                        : ('plugins.equipment-info.select-product-line' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span
                  ><strong>{{ 'plugins.equipment-info.equipment-type' | translate }}<i>*</i></strong></span
                >
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="machineForm.controls.Name"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input type="hidden" name="Name" class="ir-form-set" formControlName="Name" />
                <div class="ir-line ir-select th-select" (click)="openModelsSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      modelSelectedValue ? modelSelectedValue : ('plugins.equipment-info.select-machine' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.equipment-info.equipment-year' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group" formGroupName="data">
                <validation-message
                  [validationControl]="formData.controls.YearBuilt"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input name="YearBuilt" class="ir-form-set" type="text" formControlName="YearBuilt" />
              </div>
            </td>
          </tr>
          <ng-container [formGroup]="formData">
            <ng-container formArrayName="Serial">
              <tr *ngFor="let serial of Serial.controls; let i = index">
                <td class="margin">
                  <h2 *ngIf="i === 0">
                    <span
                      ><strong class="">{{ 'plugins.equipment-info.equipment' | translate }} # <i>*</i></strong></span
                    >
                  </h2>
                </td>
                <td class="margin">
                  <div class="ir-form-group">
                    <validation-message
                      [validationControl]="serial"
                      [validationName]="'required'"
                      [errorMessage]="'common.required' | translate"
                    ></validation-message>
                    <input name="Serial" class="ir-form-set" type="text" [formControlName]="i" />
                  </div>
                </td>
                <td *ngIf="i === 0" class="th-plugin-line--numbers">
                  <i (click)="addSerial()" class="material-icons">add_circle</i>
                </td>
                <td *ngIf="i > 0" class="th-plugin-line--remove">
                  <i (click)="removeSerial(i)" class="material-icons">remove_circle</i>
                </td>
              </tr>
            </ng-container>
          </ng-container>
          <tr>
            <td class="margin">
              <h2>
                <span
                  ><strong class=""
                    >{{ 'plugins.equipment-info.customer-equipment-id' | translate }} <i>*</i></strong
                  ></span
                >
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group" formGroupName="data">
                <validation-message
                  [validationControl]="formData.controls.CustomerEquipementId"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input
                  name="CustomerEquipementId"
                  class="ir-form-set"
                  type="text"
                  formControlName="CustomerEquipementId"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.equipment-info.maitance-contract' | translate }} #</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group" formGroupName="data">
                <validation-message
                  [validationControl]="formData.controls.MaintenanceSapContract"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input
                  name="MaintenanceSapContract"
                  class="ir-form-set"
                  type="text"
                  formControlName="MaintenanceSapContract"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.equipment-info.switched-hours' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group" formGroupName="data">
                <validation-message
                  [validationControl]="formData.controls.SwitchedOnHours"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input name="SwitchedOnHours" class="ir-form-set" type="text" formControlName="SwitchedOnHours" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.equipment-info.running-hours-no' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group" formGroupName="data">
                <validation-message
                  [validationControl]="formData.controls.RunningHoursNoSheets"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input
                  name="RunningHoursNoSheets"
                  class="ir-form-set"
                  type="text"
                  formControlName="RunningHoursNoSheets"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.equipment-info.running-hours-with' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group" formGroupName="data">
                <validation-message
                  [validationControl]="formData.controls.RunningHoursWithSheets"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input
                  name="RunningHoursWithSheets"
                  class="ir-form-set"
                  type="text"
                  formControlName="RunningHoursWithSheets"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.equipment-info.total-production' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group" formGroupName="data">
                <validation-message
                  [validationControl]="formData.controls.TotalProduction"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input name="TotalProduction" class="ir-form-set" type="text" formControlName="TotalProduction" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.equipment-info.counter-pr' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group" formGroupName="data">
                <validation-message
                  [validationControl]="formData.controls.CounterPrCycles"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input name="CounterPrCycles" class="ir-form-set" type="text" formControlName="CounterPrCycles" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.equipment-info.manual-parts-book' | translate }} #</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group" formGroupName="data">
                <input name="PartsBook" class="ir-form-set" type="text" formControlName="PartsBook" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.equipment-info.parts-book' | translate }} #</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group" formGroupName="data">
                <input name="ServerPartsBook" class="ir-form-set" type="text" formControlName="ServerPartsBook" readonly />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="machineForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
<modal (modalOutput)="selectModelsMenu($event)" (modalClosed)="onClose()" #modelsModal></modal>
<modal
  (modalOutput)="selectProductLinesMenu($event)"
  (modalClosed)="onProductLinesMenuClose()"
  #productLinesModal
></modal>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
